/**
 * Collapse partnerName (string | string[]) to one display string for UI + Tagular.
 * Trims, drops blanks, joins multiple with ", ". Uses fallback when empty.
 */
export function normalizePartnerDisplayName(
  name: string | string[] | undefined | null,
  fallback = "",
): string {
  if (name == null) return fallback;

  const parts = Array.isArray(name)
    ? name.map((p) => String(p ?? "").trim()).filter(Boolean)
    : [String(name).trim()].filter(Boolean);

  if (parts.length === 0) return fallback;
  return parts.join(", ");
}
